import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgcCookieConsentConfig, NgcCookieConsentModule} from 'ngx-cookieconsent';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname
  },
  position: 'bottom',
  theme: 'classic',
  palette: {
    popup: {
      background: '#000000',
      text: '#ffffff',
      link: '#ffffff'
    },
    button: {
      background: '#3f51b5',
      text: '#ffffff'
    }
  },
  type: 'info',
  content: {
    message: 'By using TermWebPublish you accept the terms provided in our ',
    dismiss: 'Close',
    deny: 'Decline',
    link: 'Data Privacy Policy',
    href: 'https://www.interverbumtech.com/privacy-policy/',
    policy: 'Cookie Policy'
  }
};

@NgModule({
  declarations: [],
  imports: [CommonModule, NgcCookieConsentModule.forRoot(cookieConfig)],
  exports: [NgcCookieConsentModule]
})
export class CookieConsentModule {
}
